import dayjs, { Dayjs } from 'dayjs';

export const CERTIFICATE_FILTERS_KEY = 'kalotte.filters.certificates';
export const CHARGE_FILTERS_KEY = 'kalotte.filters.charges';

export function readStoredFilters(key: string): Record<string, unknown> {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
    return parsed as Record<string, unknown>;
  } catch {
    return {};
  }
}

export function writeStoredFilters(key: string, value: Record<string, unknown>) {
  const empty = Object.values(value).every((item) => item == null || item === '');
  try {
    if (empty) localStorage.removeItem(key);
    else localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Storage can be unavailable in private mode.
  }
}

export function storedId(value: unknown): number | null {
  return typeof value === 'number' && Number.isInteger(value) && value > 0 ? value : null;
}

export function storedText(value: unknown): string {
  return typeof value === 'string' ? value : '';
}

export function storedNumber(value: unknown): number | null {
  return typeof value === 'number' && Number.isFinite(value) ? value : null;
}

export function storedDay(value: unknown): Dayjs | null {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const date = dayjs(value);
  return date.isValid() && date.year() >= 1900 ? date : null;
}

export function formatStoredDay(value: Dayjs | null): string | null {
  if (value == null || !value.isValid() || value.year() < 1900) return null;
  return value.format('YYYY-MM-DD');
}
